import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router';
import { parse } from '../../util/api.util';
import { MagicLinkContainer } from './MagicLinkContainer';

export const MagicLinkSentPage: FunctionComponent = () => {
  const { search } = useLocation();
  const { email } = parse(search);

  return (
    <MagicLinkContainer
      id="magic-link-sent-page"
      data-testid="magic-link-sent-page"
    >
      <strong>Magic Link Sent!</strong>
      <p>
        We take your privacy and security seriously. Check your email
        {email && (
          <>
            {' '}
            at <strong>{email}</strong>
          </>
        )}{' '}
        and follow the link to confirm your identity. The link is active for 96
        hours.
      </p>
    </MagicLinkContainer>
  );
};
